var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    fill: "none",
    viewBox: "0 0 50 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M25 46.63c-11.506 0-20.833-9.327-20.833-20.833C4.167 14.291 13.494 4.964 25 4.964c11.506 0 20.833 9.327 20.833 20.833 0 11.506-9.327 20.833-20.833 20.833zm0-4.166c4.42 0 8.66-1.756 11.785-4.882 3.126-3.125 4.882-7.365 4.882-11.785s-1.756-8.66-4.882-11.785C33.66 10.886 29.42 9.13 25 9.13s-8.66 1.756-11.785 4.882c-3.126 3.126-4.882 7.365-4.882 11.785s1.756 8.66 4.882 11.785C16.34 40.708 20.58 42.464 25 42.464zm2.083-16.667h8.334v4.167h-12.5V15.38h4.166v10.417z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.222a58b4e8e0c4d8703a7ef23c0e4996.svg";
export { ForwardRef as ReactComponent };